<template>
    <div>
        <div class="alldayEvent" v-for="event in allDayEvents" :key="event.id" :style="style[event.calid]"
                @click="selectEvent(event)">
            {{event.summary}}
        </div>
    </div>
</template>

<script>
export default {
  name: 'calendarAllDayView',
  props: {
    events: Array,
    date: Object
  },
  methods: {
    selectEvent(event) {
      console.log('cal event click', event);
      this.$router.push(
        { name: 'calendarEvent', params: Object.assign({}, this.$route.params, { eventId: event.id }) });
    }
  },
  computed: {
    allDayEvents() {
      const dayStart = this.date;
      const dayEnd = dayStart.endOf('day');
      let events = this.events.filter(e => {
        return (e.startDateTime <= dayEnd) && (e.endDateTime >= dayStart) && (e.allday);
      }).sort((a, b) => {
        if (a.startDateTime < b.startDateTime) {
          return -1;
        } else if (a.startDateTime > b.startDateTime) {
          return 1;
        } else {
          return a.summary.localeCompare(b.summary, 'en', { sensitivity: 'base' });
        }
      });

      return events;
    },
    style() {
      return this.$store.getters.calendarEventStyles;
    }
  }
};
</script>

<style scoped lang="scss">
    .alldayEvent {
        font-size: 0.7rem;
        margin-bottom: 2px;
        white-space: nowrap;
        overflow-x: hidden;
        text-overflow: ellipsis;
        cursor: pointer;
    }

</style>
